import type { DynamicFilterDataType } from "app/pages/sales-intelligence/domain/search/types/dynamic-filter-options";
import type { DynamicFilterMetadata, DynamicFilterValue } from "app/pages/sales-intelligence/domain/search/types/dynamic-filter-values";
import { isDynamicFilterValueEmpty } from "app/pages/sales-intelligence/domain/search/utils/dynamic-filter-values";

import type { IFilterPanelBaseFilterDeps } from "../types/filters";

import { FilterPanelBaseFilter } from "./BaseFilter";

export class DynamicFieldFilter<Raw, Options> extends FilterPanelBaseFilter<
    DynamicFilterValue,
    Options,
    Raw | undefined
> {
    private readonly dataType: DynamicFilterDataType;

    private readonly metadata?: DynamicFilterMetadata;

    constructor(
        dataType: DynamicFilterDataType,
        deps: IFilterPanelBaseFilterDeps<DynamicFilterValue, Options>,
        metadata?: DynamicFilterMetadata,
    ) {
        super(deps);

        this.dataType = dataType;
        this.metadata = metadata;
    }

    toApiValue(value?: Raw): DynamicFilterValue | undefined {
        if (value == null) {
            return undefined;
        }

        const candidate = {
            dataType: this.dataType,
            value,
            ...(this.metadata && { metadata: this.metadata }),
        } as unknown as DynamicFilterValue;

        return isDynamicFilterValueEmpty(candidate) ? undefined : candidate;
    }

    fromApiValue(value?: DynamicFilterValue): Raw | undefined {
        return value?.value as Raw | undefined;
    }

    isValueEmpty(value?: DynamicFilterValue): boolean {
        return value === undefined || isDynamicFilterValueEmpty(value);
    }
}
